import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { FaLocationDot } from "react-icons/fa6";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { Pagination, Navigation } from "swiper/modules";

// Import Swiper styles
import image from "../../../../../../assets/images/placeholder.jpg";
import "swiper/css/pagination";
import "swiper/css";
import { useGetAllAreasQuery } from "../../../../../../setup/rtk-query/APIs/areaApi";
import { Link, useParams } from "react-router-dom/dist";
import { Line } from "rc-progress";
import { SyncLoader } from "react-spinners";
import { Alert } from "react-bootstrap";

function AreasList({parent}) {
  const area = useParams()?.area?.split("-")?.join(" ");
  const { data, isError, error, isLoading } = useGetAllAreasQuery();
  const [show, setShow] = useState(false)
  const [search, setsearch] = useState()

  useEffect(() => {
    const search = data?.data?.find((item)=>{
      return item?.verified === true
    })
    setsearch(search)
  }, [data])
  

  if(!search){
    return (<>
        <div className="main-heading">
          {parent=="area page" ? (
            <h3 className="fw-light mt-4">No Other Areas Available</h3>

          ) : (
            <h3 className="fw-light mt-4">No Areas Available Yet</h3>
          )}
        </div>
    </>)
  }

  return (
    <>
    {isError ? (
              <Alert
                variant="danger"
                onClose={() => setShow(false)}
                dismissible
              >
                {error?.data?.error}
              </Alert>
            ) : (
              ""
            )}
            {isLoading ? <SyncLoader className="text-center pb-5 mt-5 pt-5 m-auto" size={12}  color="#009f3b" /> : 
            <div>
                    <Swiper
        spaceBetween={30}
        navigation={{
          nextEl: `.swiper-button-next`,
          prevEl: `.swiper-button-prev`,
        }}
        breakpoints={{
          0: {
            slidesPerView: 1,
          },
          500: {
            slidesPerView: 2,
          },
          992: {
            slidesPerView: 3,
          },
          1200: {
            slidesPerView: 4,
          },
        }}
        modules={[Pagination, Navigation]}
        className="swiper"
      >
        {data?.data?.map((item, index) =>
          item?.verified && item?.name != area?.toLowerCase() ? (
            <SwiperSlide key={index}>
              <Link
                style={{ textDecoration: "none" }}
                to={`/areas/${item?.name?.split(" ").join("-")}`}
              >
                <div className="item">
                  <div className="image">
                    <img src={item?.coverImage || image} alt="" />
                  </div>
                  <Line
                    trailWidth={3}
                    percent={item?.monthPct}
                    strokeWidth={3}
                    strokeColor="#009f3b"
                  />
                  <div className="text">
                    <h4>{item.name}</h4>
                    <div className="location">
                      <div className="icon">
                        <FaLocationDot />
                      </div>
                      <span>{`${item?.concelho},${item?.distrito} Portugal`}</span>
                    </div>
                  </div>
                </div>
              </Link>
            </SwiperSlide>
          ) : (
            ""
          )
        )}
      </Swiper>
      <div className="pagin">
        <div className={`flex-center swiper-button-prev prev`}>
          <IoIosArrowBack onClick={() => {}} />
        </div>
        <div className={`flex-center swiper-button-next next`}>
          <IoIosArrowForward onClick={() => {}} />
        </div>
      </div>
            </div>
            }


    </>
  );
}

export default AreasList;
